export default __webpack_public_path__ + "static/media/chart-bar.d873d8a4.svg";